define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var Class = require('Class');
    var CommonFormClass = require('class/form.class');
    var i18n = require('i18n');

    var Form = Class.create(CommonFormClass, {

        delegateEvents: function() {
            CommonFormClass.prototype.delegateEvents.apply(this, arguments);
            this.$el.find('input')
                .on('focusin.form', function(event) {

                    let $field = $(event.target).parents('.field');
                    let validationType = $field[0].dataset.validationType;
                    let $form = $(event.target).parents('.form_name_login');
                    let isLoginPopup = $form.hasClass('form_name_login');

                    this.removeErrorTooltip($field);

                    let message = i18n.tExt(`playtech.mobile.registration.positive-tooltip.${validationType}`, ' ');

                    if (message && !isLoginPopup) {

                        this.showPositiveTooltip($field, {
                            message: message
                        });
                    }
                }.bind(this))
                .on('focusout.form', function(event) {
                    let $field = $(event.target).parents('.field');
                    this.removePositiveTooltip($field);
                }.bind(this));

            return this;
        },

        showPositiveTooltip: function($field, data) {
            var $errorTooltip = $field.find('.positive-tooltip');

            if ($errorTooltip.length === 0) {

                $field.append(`<div class="positive-tooltip">${data.message}</div>`);
            } else {

                $errorTooltip.html(data.message);
            }

            return this;
        },

        removePositiveTooltip: function($field) {
            $field.find('.positive-tooltip').remove();

            return this;
        },

        showErrorTooltip: function($field, data) {
            var $errorTooltip = $field.find('.error-tooltip');
            var message = i18n.t(data.dynamicMessage || data.message);

            if (!message) {
                return;
            } else if ($errorTooltip.length === 0) {
                $field.append('<div class="error-tooltip" data-auto="auto-error_tooltip">' + message + '</div>');
            } else {
                $errorTooltip.html(message);
            }

            this.removePositiveTooltip($field);

            return this;
        },

        addPasswordVisibilityControl: function(passwordInputEl) {
            var showText = i18n.t('playtech.mobile.system.registration.showPassword');

            $(passwordInputEl)
                .addClass('fn-input-type-password')
                .parent()
                .addClass('field_name_password_view')
                .parent()
                .append(`<div class="password-visibility fn-toggle-password-visibility">${showText}</div>`);
        },
        /**
         * Toggle password input element text visibility
         *
         * @param {jBone.Event} e
         **/
        handleTogglePasswordVisibility: function(e) {
            e.stopPropagation();
            e.preventDefault();
            var $passwordVisibilityControl = $(e.target);
            var showText = i18n.t('playtech.mobile.system.registration.showPassword');
            var hideText = i18n.t('playtech.mobile.system.registration.hidePassword');
            var $inputPassword = $passwordVisibilityControl.parent().find('.fn-input-type-password');
            var $isPassword = $inputPassword.attr('type') === 'password';
            var passwordVisibilityStatus = $isPassword ? hideText : showText;

            $passwordVisibilityControl.toggleClass('password-visibility--enabled');
            $passwordVisibilityControl.html(passwordVisibilityStatus);
            $inputPassword.attr('type', $isPassword ? 'text' : 'password');
    }
    });

    module.exports = Form;

    Form.toggleLoading = CommonFormClass.toggleLoading;
    Form.refreshSelectField = CommonFormClass.refreshSelectField;
    Form.toggleFieldVisibility = CommonFormClass.toggleFieldVisibility;
});
